/***
 *
 *   SETTINGS SHELL
 *   Phase 8 — reference SettingsShell: vertical nav rail + flexible body.
 *   Keep route-per-section (no ?section=). AppLayout already provides
 *   ContentContainer gutters — do not nest another one here.
 *
 **********/

import React from 'react';
import { AccountNav } from 'components/lib';
import Style from './settings.tailwind';

export const SettingsWrapper = (props) => {
    return (
        <div className={Style.shell}>
            <aside className={Style.rail}>
                <AccountNav />
            </aside>
            <div className={Style.body}>{props.children}</div>
        </div>
    );
};
